import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { INDRABookingService } from "@ibe.services/booking.indra.service";
import { URL_BOOKING_MARKET, MOCK_STATUS, MOCK_URL_BOOKING_MARKET } from '@ibe.config';


@Injectable({
	providedIn: 'root'
})
export class INDRALocationService {

	constructor(
		private api: INDRAApiService,
		private http: HttpClient,
		protected bookingService: INDRABookingService
	) {
	}
	
	
	/** Returns an array of special locations/country
	 *  that will be used depending on each countries' rules.
	 *	This method will be used in the long run
	 *	after updating the other sidebars */
	public INDRA_getSpecialCaseLocation(countries: Array<string>, flightSegments, flightIdentifier: string): Array<string> {
		let specialCaseCountries: Array<string> = [];
		flightSegments.forEach(flight => {
			flight.listSegment.forEach(
				segment => {
					let segmentDeparture = this.bookingService.INDRA_getLocation(segment.departureAirport);
					let segmentArrival = this.bookingService.INDRA_getLocation(segment.arrivalAirport);
					let filteredCountries = countries.filter(
						country => {
							return country === segmentDeparture.countryCode || country === segmentArrival.countryCode;
						}
					)
					specialCaseCountries = specialCaseCountries.concat(filteredCountries);
				}
			)
		});
		return specialCaseCountries;
	}

	public INDRA_setBookingMarket(market: string, defaultLanguage: string): Observable<any> {
		// If idOperation is present on current URL, do NOT call market
		var urlParams = new URLSearchParams(window.location.search);
		const idOperation = urlParams.get('idOperation');

		if (MOCK_STATUS.BOOKING_MARKET) {
			return this.api.INDRA_get(MOCK_URL_BOOKING_MARKET);
		} else {
			if (idOperation && idOperation.length) {
				return this.api.INDRA_post(URL_BOOKING_MARKET, { 'market': market, 'language': defaultLanguage, 'idOperation': idOperation });
			} else {
				return this.api.INDRA_post(URL_BOOKING_MARKET, { 'market': market, 'language': defaultLanguage });
			}
		}
	}
}